(ns kyber.feature-flags
  (:require [kyber.constants :as c]
            [common.transit :as t]))

;; Read raw transit config
(def config (t/read c/serialized-feature-flags-config))

(defn purge-stale 
  "Purge old feature-flags based on feature flags present in feature-flags config"
  [{:keys [feature-flags feature-flags-config]}]
  (into {}
        (map
         (fn [[app flags]]
           {app (->> feature-flags-config
                     app
                     (map :id)
                     (select-keys flags))})
         feature-flags)))

(defn feature-enabled?
  "Given a feature-flag id (keyword), returns true when the feature is enabled."
  [id]
  (boolean
   (when (some? @c/app-name)
     (when (some #(= id (:id %)) (get config (keyword @c/app-name)))
       (get-in c/feature-flags [(keyword @c/app-name) id :enabled])))))

(defn some-feature-enabled?
  "Takes a set of feature-flag ids, and returns true if any of the features are enabled."
  [ids]
  (boolean (some feature-enabled? ids)))

(defn every-feature-enabled?
  "Takes a set of feature-flag ids, and returns true if all of the features are enabled."
  [ids]
  (boolean (every? feature-enabled? ids)))
